import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46139f38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product__subtitle" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { BasicModelBasicInfoList } from '@components/basic'
import PackageDetailsHeader from '@components/packages/PackageDetailsHeader.vue'
import CombinationDetailsList from '@components/combinations/CombinationDetailsList.vue'
import ProductDetailsList from '@/components/products/ProductDetailsList.vue'
import { TPackage } from '@/const/types/package'
import { computed } from 'vue'

interface Props {
  item: TPackage;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PackageDetailsView',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: TPackage;
};



const articleName = computed(() => props.item.combination ? `${props.item.combination.product.name} | ${props.item.combination.name}` : props.item.product.name)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PackageDetailsHeader, {
      code: props.item.combination ? props.item.combination.code : props.item.product.code
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(articleName)) + " ", 1),
        _createElementVNode("span", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(" Package: " + _toDisplayString(props.item.name), 1)
        ])
      ]),
      _: 1
    }, 8, ["code"]),
    _createVNode(_unref(BasicModelBasicInfoList), {
      model: props.item,
      "additional-keys": ['capacity'],
      "model-name": "Package"
    }, null, 8, ["model"]),
    (props.item.combination)
      ? (_openBlock(), _createBlock(CombinationDetailsList, {
          key: 0,
          combination: props.item.combination
        }, null, 8, ["combination"]))
      : (_openBlock(), _createBlock(ProductDetailsList, {
          key: 1,
          product: props.item.product
        }, null, 8, ["product"]))
  ]))
}
}

})